module.exports = __webpack_public_path__ + "assets/img/15da-do.svg";